import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-principal-public',
  templateUrl: './principal-public.component.html',
  styleUrls: ['./principal-public.component.css']
})
export class PrincipalPublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
